import { render } from "./carousel-component.vue?vue&type=template&id=6d11a01d&scoped=true"
import script from "./carousel-component.vue?vue&type=script&lang=js"
export * from "./carousel-component.vue?vue&type=script&lang=js"

import "./carousel-component.vue?vue&type=style&index=0&id=6d11a01d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d11a01d"]])

export default __exports__